<div class="layout__inner-card">
  <h4 i18n>Détails de la personne</h4>
  <div class="layout--gap margin--bottom-small">
    <div class="layout--full-width">
      <label class="label-top" for="gender" i18n>Sexe</label>
      <input [ngModel]="data.sex" id="gender" type="text" pInputText disabled />
    </div>
    <div class="layout--full-width">
      <label class="label-top" for="occupation" i18n>Occupation</label>
      <input [ngModel]="data.occupation" id="occupation" type="text" pInputText disabled />
    </div>
    <div class="layout--full-width">
      <label class="label-top" for="birthdate" i18n>Date de naissance</label>
      <input [ngModel]="data.birthday" id="birthdate" type="text" pInputText disabled />
    </div>
  </div>

  <div class="layout--gap margin--bottom-small">
    <div class="layout--full-width">
      <label class="label-top" for="birthPlace" i18n>Endroit de naissance</label>
      <input [ngModel]="birthPlace" id="birthPlace" type="text" pInputText disabled />
    </div>
    <div class="layout--full-width">
      <label class="label-top" for="residencePlace" i18n>Endroit de résidence</label>
      <input [ngModel]="residencePlace" id="residencePlace" type="text" pInputText disabled />
    </div>
    <div class="layout--full-width">
      <label class="label-top" for="alternateBirthdays" i18n>Dates de naissance alternatives</label>
      <input [ngModel]="alternateBirthdays" id="alternateBirthdays" type="text" pInputText disabled />
    </div>
  </div>
</div>
